/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { RapportManagerDto } from '../models/rapport-manager-dto';


/**
 * Fonctions de gestion des rapports des managers
 */
@Injectable({
  providedIn: 'root',
})
export class RapportsManagersService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation rapportManagerGetList
   */
  static readonly RapportManagerGetListPath = '/api/rapports-managers/list';

  /**
   * Renvoie la liste des rapports des managers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportManagerGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportManagerGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<RapportManagerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsManagersService.RapportManagerGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RapportManagerDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des rapports des managers.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportManagerGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportManagerGetList(params?: {
  }): Observable<Array<RapportManagerDto>> {

    return this.rapportManagerGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RapportManagerDto>>) => r.body as Array<RapportManagerDto>)
    );
  }

  /**
   * Path part for operation rapportManagerLoadList
   */
  static readonly RapportManagerLoadListPath = '/api/rapports-managers/load-list';

  /**
   * Renvoie la liste des rapports des managers (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportManagerLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportManagerLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsManagersService.RapportManagerLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des rapports des managers (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportManagerLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportManagerLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.rapportManagerLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation rapportManagerGet
   */
  static readonly RapportManagerGetPath = '/api/rapports-managers/{id}';

  /**
   * Renvoie le rapport d'un manager spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportManagerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportManagerGet$Response(params: {

    /**
     * Identifiant du rapport d&#x27;un manager
     */
    id: number;
  }): Observable<StrictHttpResponse<RapportManagerDto>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsManagersService.RapportManagerGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RapportManagerDto>;
      })
    );
  }

  /**
   * Renvoie le rapport d'un manager spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportManagerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportManagerGet(params: {

    /**
     * Identifiant du rapport d&#x27;un manager
     */
    id: number;
  }): Observable<RapportManagerDto> {

    return this.rapportManagerGet$Response(params).pipe(
      map((r: StrictHttpResponse<RapportManagerDto>) => r.body as RapportManagerDto)
    );
  }

  /**
   * Path part for operation rapportManagerPut
   */
  static readonly RapportManagerPutPath = '/api/rapports-managers/{id}';

  /**
   * Met à jour le rapport d'un manager spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportManagerPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportManagerPut$Response(params: {

    /**
     * Identifiant du rapport d&#x27;un manager à mettre à jour
     */
    id: number;

    /**
     * Rapport d'un manager
     */
    body: RapportManagerDto
  }): Observable<StrictHttpResponse<RapportManagerDto>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsManagersService.RapportManagerPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RapportManagerDto>;
      })
    );
  }

  /**
   * Met à jour le rapport d'un manager spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportManagerPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportManagerPut(params: {

    /**
     * Identifiant du rapport d&#x27;un manager à mettre à jour
     */
    id: number;

    /**
     * Rapport d'un manager
     */
    body: RapportManagerDto
  }): Observable<RapportManagerDto> {

    return this.rapportManagerPut$Response(params).pipe(
      map((r: StrictHttpResponse<RapportManagerDto>) => r.body as RapportManagerDto)
    );
  }

  /**
   * Path part for operation rapportManagerDelete
   */
  static readonly RapportManagerDeletePath = '/api/rapports-managers/{id}';

  /**
   * Supprime le rapport d'un manager spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportManagerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportManagerDelete$Response(params: {

    /**
     * Identifiant du rapport d&#x27;un manager à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsManagersService.RapportManagerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le rapport d'un manager spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportManagerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportManagerDelete(params: {

    /**
     * Identifiant du rapport d&#x27;un manager à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.rapportManagerDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation rapportManagerPost
   */
  static readonly RapportManagerPostPath = '/api/rapports-managers';

  /**
   * Crée le rapport d'un manager spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportManagerPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportManagerPost$Response(params: {

    /**
     * Rapport d'un manager
     */
    body: RapportManagerDto
  }): Observable<StrictHttpResponse<RapportManagerDto>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsManagersService.RapportManagerPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RapportManagerDto>;
      })
    );
  }

  /**
   * Crée le rapport d'un manager spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportManagerPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportManagerPost(params: {

    /**
     * Rapport d'un manager
     */
    body: RapportManagerDto
  }): Observable<RapportManagerDto> {

    return this.rapportManagerPost$Response(params).pipe(
      map((r: StrictHttpResponse<RapportManagerDto>) => r.body as RapportManagerDto)
    );
  }

}
